module.exports = __webpack_public_path__ + "img/swiper-msds.26d8b340.png";